module.exports = __webpack_public_path__ + "static/media/zoho.a15b0cf0.png";